import type { DomainSpecificConfig } from '../types';

const config: DomainSpecificConfig = {
  domains: [/localhost:.*/, /teacher.localhost.*/, /login.localhost.*/],
  domainType: 'school',
};

export default config;
